import {
	CampaignDTO,
	CampaignStatusFilter,
	getCampaignStatusGroup
} from './campaign-status'

const statusOrder: Record<CampaignStatusFilter, number> = {
	ACTIVE: 0,
	PAUSED: 1,
	REMOVED: 2
}
const platformOrder: Record<string, number> = { GADS: 0, BADS: 1, FADS: 2 }
const nameCollator = new Intl.Collator('en', { sensitivity: 'base' })

/** Display order only: never mutate the incoming list or campaign objects. */
export const sortCampaigns = (
	campaigns: readonly CampaignDTO[],
	adAccountPlatforms: Readonly<Record<string, string>>
): CampaignDTO[] => {
	const statusRank = (campaign: CampaignDTO) => {
		const group = getCampaignStatusGroup(campaign)
		return group === null ? 3 : statusOrder[group]
	}
	const platformRank = (campaign: CampaignDTO) =>
		platformOrder[adAccountPlatforms[campaign.ad_account_id]] ?? 3

	return [...campaigns].sort(
		(a, b) =>
			statusRank(a) - statusRank(b) ||
			platformRank(a) - platformRank(b) ||
			nameCollator.compare(a.name ?? '', b.name ?? '')
	)
}
